import React from 'react';
import { useParams } from 'react-router-dom'
import ZxingReader from './component/zxingReader';

import { makeStyles, Snackbar, CssBaseline, Button, AppBar, Toolbar, Typography } from '@material-ui/core';

import User, { demo_val } from './model/User';

const useStyles = makeStyles(theme => ({
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
    },
    toolbar: theme.mixins.toolbar,
    button: {
        marginTop: theme.spacing(2),
    },
}))

const SignIn: React.FC = () => {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [openScanDialog, setOpenScanDialog] = React.useState<boolean>(false);
    const { userId, subjectId } = useParams();

    const userFromQrContent = (qrContent: string): User | null => {
        let user = User.fromURL(qrContent);
        if (user !== null) return user;
        user = User.fromQR(qrContent);
        if (user !== null) return user;
        return null;
    }

    if (userId !== undefined && subjectId !== undefined) {
        console.log("login true");
        const user = new User();
        user.save(userId, subjectId);
        window.location.href = "/";
    } else {
        console.log("login false");
    }

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" >
                <Toolbar >
                    <Typography variant="h6" noWrap>Регистрация</Typography>
                </Toolbar>
            </AppBar>

            <div className={classes.content} >
                <div className={classes.toolbar} />
                <Typography variant="body1" >
                    Для продолжения необходима <b>регистрация</b>, пожалуйста, свяжитесь с администратором системы в вашем филиале.
                    </Typography>
                <br />
                <Button fullWidth color="secondary" className={classes.button}
                    variant={"outlined"}
                    onClick={() => {
                        let user = new User();
                        user.save(demo_val, demo_val);
                        window.location.reload();
                    }}>тестовая среда
                    </Button>

                <Button fullWidth color="secondary" className={classes.button}
                    variant='contained'
                    onClick={() => setOpenScanDialog(true)}>
                    сканировать QR</Button>

                {openScanDialog ?
                    <ZxingReader
                        onResult={(data: any) => {
                            let user = userFromQrContent(data);
                            if (user !== null) {
                                user.save(user.userId, user.subjectId);
                                window.location.reload();
                            } else {
                                setErrorMessage('невалидный QR-код');
                                setOpenScanDialog(false);
                                console.error('invalid user qr-code');
                            }
                        }}
                        onError={(msg: string) => {
                            setErrorMessage(msg);
                            setOpenScanDialog(false);
                        }}
                        onCancel={() => setOpenScanDialog(false)}
                    /> : null
                }
            </div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onClose={() => setOpenScanDialog(false)}
                open={Boolean(errorMessage)}
                autoHideDuration={4000}
                message={<span >{errorMessage}</span>}
            />
        </div >
    );
}

export default SignIn;
